import { Backdrop, CircularProgress, Box, Grid, Typography, TextField } from '@mui/material';
import { SubmitButton } from './SubmitButton';
import { PageName } from '../index';
import { useRef, useState } from 'react';
import { useCognitoAuth } from '@/hooks/useCognitoAuth';
import { resendSignUpCode } from 'aws-amplify/auth';

export function InputTokenForm(props: any) {
  const [isSubmitDisabled, setIsSubmitDisabled] = useState(true);
  const [open, setOpen] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  let tokenFormRef = useRef<HTMLInputElement>(null);
  const { handleConfirmSignUp } = useCognitoAuth();

  const handleTokenSubmit = async () => {
    const token = tokenFormRef.current!.value.trim();
    if (token !== '') {
      setOpen(true);
      try {
        await handleConfirmSignUp(props.username, token);
        props.setActivePage(PageName.AfterRegister);
      } catch (e) {
        console.log(e);
        setErrorMessage('ご入力いただいた認証コードが異なります。再度ご確認ください。');
      } finally {
        setOpen(false);
      }
    }
  };

  const ErrorMessage = (props: { message: string | undefined }) => {
    if (!props.message) return null;
    return (
      <Typography color="error" style={{ fontSize: '12px', marginLeft: '4px' }}>
        {props.message}
      </Typography>
    );
  };

  const handleResendSignUpCode = async () => {
    setOpen(true);
    try {
      await resendSignUpCode({ username: props.username });
    } catch (error) {
      if (typeof error === 'object' && error != null && 'name' in error) {
        switch (error.name) {
          case 'LimitExceededException':
            setErrorMessage('問題が発生しました。少し時間をおいて再度お試しください。');
            break;
          default:
            setErrorMessage('問題が発生しました。再度確認して入力してください。');
        }
      } else {
        setErrorMessage('問題が発生しました。再度確認して入力してください。');
      }
    } finally {
      setOpen(false);
    }
  };

  return (
    <>
      <Box sx={{ p: 2 }}>
        <Grid container direction={'row'} spacing={2}>
          <Grid item xs={0} md={3} sm={2} />
          <Grid item xs={12} md={6} sm={8}>
            <Grid container direction={'column'} spacing={2}>
              <Grid item xs={12} mt={2} sx={{ textAlign: 'center', maxWidth: '100% !important' }}>
                <Typography mb={2} pt={2} fontSize={'16px'} className="font-bold">
                  2段階認証
                </Typography>
                <Typography mb={2} pt={2} fontSize={'14px'}>
                  認証コードをメールでお送りしました
                  <br />
                  メールに記載されている認証コードを
                  <br />
                  入力してください
                </Typography>
              </Grid>
              <Grid item xs={12} sx={{ textAlign: 'left', maxWidth: '100% !important' }}>
                <Typography m={0.5} fontSize={'14px'} className="font-bold">
                  認証コード
                </Typography>
                <TextField
                  type="password"
                  inputRef={tokenFormRef}
                  fullWidth
                  size="small"
                  sx={{ backgroundColor: '#fff' }}
                  onChange={(e) => {
                    if (e.currentTarget.value.trim() === '') {
                      setIsSubmitDisabled(true);
                    } else if (isSubmitDisabled) {
                      setIsSubmitDisabled(false);
                    }
                  }}
                />
                <SubmitButton disabled={isSubmitDisabled} label={'送信する'} onClick={handleTokenSubmit} />
                {errorMessage && <ErrorMessage message={errorMessage} />}
                <Grid item xs={12} mt={2} sx={{ textAlign: 'center', maxWidth: '100% !important' }}>
                  <button
                    onClick={() => handleResendSignUpCode()}
                    style={{ color: '#1976d2', borderBottom: '1px solid', fontSize: '12px' }}
                  >
                    認証コードの再送はこちら
                  </button>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Box>
      <Backdrop sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }} open={open}>
        <CircularProgress color="inherit" />
      </Backdrop>
    </>
  );
}
